import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Paper
} from "@mui/material";
import { Add, Edit, Delete, ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "./api/apiClient";

const Roles = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await api.get("/roles");
      setRoles(response.data);
    } catch (error) {
      console.error("Error fetching roles", error);
    }
  };

  const handleBack = () => {
    navigate(-1); // Navigate to previous screen
  };

  return (
    <Box sx={{ width: "90%", margin: "auto", mt: 5 }}>
      {/* Header with Back Button */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={handleBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ ml: 1 }}>
          Roles List
        </Typography>
      </Box>

      {/* Add Role Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        <Tooltip title="Add Role">
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate("/rolemaintenance")}
          >
            Add Role
          </Button>
        </Tooltip>
      </Box>

      {/* Roles Table */}
      <TableContainer
        component={Paper}
        sx={{ maxHeight: 400, overflowY: "auto" }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "30%" }}><strong>Role ID</strong></TableCell>
              <TableCell sx={{ width: "50%" }}><strong>Role Name</strong></TableCell>
              <TableCell sx={{ width: "20%" }}><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles.map((role) => (
              <TableRow key={role.id} sx={{ height: 36 }}>
                <TableCell>{role.id}</TableCell>
                <TableCell>{role.name}</TableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => navigate(`/rolemaintenance/${role.id}`)}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton color="error">
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Box>
  );
};

export default Roles;
